export const getBoilerAgeNumber = (
  age: string | number | undefined,
): number => {
  if (typeof age === 'number') {
    return isNaN(age) ? 0 : age;
  }
  if (typeof age !== 'string') {
    return 0;
  }

  let cleanValue = age.trim();

  if (cleanValue.endsWith('+')) {
    cleanValue = cleanValue.slice(0, -1);
  }

  const ageNumber = Number(cleanValue);

  return isNaN(ageNumber) ? 0 : ageNumber;
};
